import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import MiniDashboard from '../components/MiniDashboard';
import { FileText, Mail, CheckCircle, Clock, XCircle, Eye, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AppointmentLetterFlow({ user, onLogout }) {
  const [pendingLetters, setPendingLetters] = useState([]);
  const [signedLetters, setSignedLetters] = useState([]);
  const [activeTab, setActiveTab] = useState('pending');
  const [dashboardStats, setDashboardStats] = useState(null);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/dashboard/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDashboardStats(response.data);
    } catch (error) {
      console.error('Failed:', error);
    }
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold" style={{color: '#2b3380'}}>Appointment Letters</h1>
          <p className="text-gray-600 mt-2">Track appointment letter e-signatures</p>
        </div>

        {dashboardStats && (
          <MiniDashboard
            title="Appointment Letter Overview"
            icon="📄"
            bgColor="#5c6bc0"
            stats={[
              { label: 'Pending', value: 0, subtitle: 'Awaiting', color: '#ff9800' },
              { label: 'Signed', value: 0, subtitle: 'Completed', color: '#4caf50' },
              { label: 'Total', value: 0, subtitle: 'All time', color: '#2b3380' },
              { label: 'Rate', value: 0, subtitle: 'Percentage', color: '#5c6bc0' }
            ]}
          />
        )}

        <div className="bg-white rounded-lg shadow-md p-12 text-center">
          <FileText className="w-16 h-16 mx-auto mb-4" style={{color: '#cccccc'}} />
          <h3 className="text-lg font-medium mb-2">No appointment letters yet</h3>
          <p className="text-gray-600">Letters will appear here when generated</p>
        </div>
      </div>
    </Layout>
  );
}

export default AppointmentLetterFlow;
